import { HttpResponseBase } from '@angular/common/http';
import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription, throwError } from 'rxjs';

import { ConsentManagementService } from '@app/open-insurance/modules/consent-management/consent-management.service';
import { ICONS_ENUM } from '@app/open-insurance/shared/constants/icons';
import {
  OPEN_INSURANCE_ROUTE,
  SHARED_CONSENTS_ROUTES
} from '@app/open-insurance/shared/constants/routes';

import { IRevokeSharingDialogDetail } from './revoke-sharing-dialog.model';

@Component({
  selector: 'app-revoke-sharing-dialog',
  templateUrl: './revoke-sharing-dialog.component.html',
  styleUrls: ['./revoke-sharing-dialog.component.scss'],
  standalone: false
})
export class RevokeDialogComponent implements OnDestroy {
  ICONS = ICONS_ENUM;

  private readonly RevokeSharingDialogComponentSubscriptions: Subscription[] =
    [];

  constructor(
    private readonly dialog: MatDialog,
    private readonly consentManagementService: ConsentManagementService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA)
    public readonly details: IRevokeSharingDialogDetail
  ) {}

  async handleRevokeSharing() {
    try {
      if (this.details.type === 'transmission') {
        await this.consentManagementService.revokeTransmissionConsentByID(
          this.details.sharingConsentID
        );

        this.router.navigateByUrl(
          `${OPEN_INSURANCE_ROUTE + '/' + SHARED_CONSENTS_ROUTES.SENT}`
        );
      } else {
        await this.consentManagementService.revokeReceptionConsentByID(
          this.details.sharingConsentID
        );

        this.router.navigateByUrl(
          `${OPEN_INSURANCE_ROUTE + '/' + SHARED_CONSENTS_ROUTES.RECEIVED}`
        );
      }
    } catch (error) {
      if (error instanceof HttpResponseBase) {
        return;
      } else {
        throwError(() => error);
      }
    } finally {
      this.dialog.closeAll();
    }
  }

  ngOnDestroy(): void {
    this.RevokeSharingDialogComponentSubscriptions.forEach((subscription) =>
      subscription.unsubscribe()
    );
  }
}
